export const newsCategories = ["全部", "影视动态", "幕后花絮", "影展资讯", "深度观察"];

export const newsList = [
  {
    id: "n-001",
    title: "经典重映：影片4K修复版登陆院线引热议",
    date: "2026-09-30",
    category: "影视动态",
    excerpt:
      "时隔多年，影片以4K修复版本重回大银幕，细腻的画质与重新校准的音效，让不少观众直言'像看了一部新片'。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20photograph%20of%20a%20grand%20old%20cinema%20marquee%20glowing%20at%20night%20with%20warm%20amber%20and%20red%20light%2C%20nostalgic%20atmospheric%2C%20no%20text&width=800&height=500&seq=news-cover-01&orientation=landscape",
    source: "本站编辑",
  },
  {
    id: "n-002",
    title: "幕后花絮：美术团队如何还原一个时代",
    date: "2026-09-24",
    category: "幕后花絮",
    excerpt:
      "从一张旧照片到一间完整的房间，美术团队用数月时间考据细节，只为让每一处陈设都经得起镜头的凝视。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20photograph%20of%20a%20vintage%20film%20set%20with%20warm%20amber%20lighting%20and%20red%20curtain%20props%2C%20behind%20the%20scenes%20moody%20atmosphere%2C%20no%20text&width=800&height=500&seq=news-cover-02&orientation=landscape",
    source: "本站编辑",
  },
  {
    id: "n-003",
    title: "影展专题：那些年在国际舞台上的华语佳作",
    date: "2026-09-18",
    category: "影展资讯",
    excerpt:
      "国际影展历来是华语电影走向世界的重要窗口。本文盘点近年备受瞩目的华语参展作品，回顾它们留下的高光时刻。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20photograph%20of%20an%20elegant%20film%20festival%20red%20carpet%20with%20warm%20golden%20lights%20at%20night%2C%20glamorous%20atmospheric%2C%20no%20text&width=800&height=500&seq=news-cover-03&orientation=landscape",
    source: "本站编辑",
  },
  {
    id: "n-004",
    title: "深度观察：为什么我们依然需要严肃电影",
    date: "2026-09-11",
    category: "深度观察",
    excerpt:
      "在快节奏的娱乐时代，严肃电影似乎越来越'不合时宜'。但也正是它们，替我们保存了思考与共情的能力。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20photograph%20of%20a%20lone%20viewer%20silhouette%20in%20a%20dark%20theater%20facing%20a%20glowing%20screen%2C%20warm%20amber%20and%20red%20tones%2C%20moody%20atmospheric%2C%20no%20text&width=800&height=500&seq=news-cover-04&orientation=landscape",
    source: "本站编辑",
  },
  {
    id: "n-005",
    title: "后记：演员谈拍摄中最难忘的一场戏",
    date: "2026-09-04",
    category: "幕后花絮",
    excerpt:
      "谈起拍摄经历，演员坦言最难的不是情绪爆发的戏份，而是那些需要长时间沉默对视的镜头。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20photograph%20of%20a%20dim%20dressing%20room%20with%20mirror%20and%20warm%20lamp%20light%2C%20red%20accents%2C%20moody%20vintage%20backstage%20atmosphere%2C%20no%20text&width=800&height=500&seq=news-cover-05&orientation=landscape",
    source: "本站编辑",
  },
  {
    id: "n-006",
    title: "档案：影片配乐背后的创作故事",
    date: "2026-08-28",
    category: "幕后花絮",
    excerpt:
      "为了找到最贴合时代的旋律，配乐团队翻遍了老唱片，甚至专门复刻了当年的演奏方式。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20photograph%20of%20a%20vintage%20vinyl%20record%20player%20spinning%20under%20warm%20amber%20light%2C%20deep%20crimson%20accent%2C%20moody%20nostalgic%20atmosphere%2C%20no%20text&width=800&height=500&seq=news-cover-06&orientation=landscape",
    source: "本站编辑",
  },
  {
    id: "n-007",
    title: "观察：经典影片的数字修复，究竟修复了什么",
    date: "2026-08-20",
    category: "深度观察",
    excerpt:
      "数字修复不只是让画面变清晰，更需要在不破坏原始质感的前提下，还原创作者最初的视听意图。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20photograph%20of%20old%20film%20reels%20and%20editing%20equipment%20under%20warm%20light%2C%20moody%20nostalgic%20atmosphere%2C%20deep%20crimson%20accent%2C%20no%20text&width=800&height=500&seq=news-cover-07&orientation=landscape",
    source: "本站编辑",
  },
  {
    id: "n-008",
    title: "盘点：影迷心中最难忘的十个电影瞬间",
    date: "2026-08-12",
    category: "影视动态",
    excerpt:
      "有些画面，看过一次就再也忘不掉。我们整理了影迷们票选出的十个经典瞬间，看看有没有你的心头好。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20photograph%20collage%20mood%20of%20glowing%20movie%20screen%20light%20in%20dark%20theater%2C%20warm%20amber%20and%20red%20tones%2C%20moody%20atmospheric%2C%20no%20text&width=800&height=500&seq=news-cover-08&orientation=landscape",
    source: "本站编辑",
  },
];